import { post } from "../index";

export const createRole = (body) => {
  return post(`/roles/role-with-permission`, body);
};
 